/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".form-desc[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%]{display:block;margin-top:15px}.tag-circle[_ngcontent-%COMP%]{width:30px;height:30px;border-radius:30px}"];
export { styles as styles };
